import React from "react";
import logo from "../assets/images/logo.webp";
export default function Navbar({PhoneNumber}) {
  const formatPhoneNumberForTel = (number) => {
    return number.replace(/\D/g, "");
  };

  const telPhoneNumber = `+1${formatPhoneNumberForTel(PhoneNumber.PhoneNo)}`;
  return (
    <div>
      <div className="Navbar ">
        <div className="Navbar-c">
          <div className="logo">
            <a href="/"><img src={logo} alt="" /></a>
          </div>
          <div className="btn-group">
            <a  href={`tel:${telPhoneNumber}`}> Call Now: {PhoneNumber.PhoneNo}</a>
          </div>
        </div>
      </div>
    </div>
  );
}
